// SourcesPanel.jsx
import React, { useEffect, useRef, useState } from "react";
import NoteBookRichTextEditor from "./NoteBookRichTextEditor";
import ApiServices from "../../utils/apiServices";
import { sanitize } from "dompurify";
import NoteBookExport from "./PopUpGenAINoteBook/NoteBookExport";
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu, hideMenu } from "react-contextmenu";
import { imsLoader } from "../../assets";
const items = [
    { id: "s1", title: "Trends in health, wealth,...." },
    { id: "s2", title: "Trends in health, wealth,...." },
    { id: "s3", title: "Trends in health, wealth,...." },
];

export default function SummaryPanel(props) {
    const [checkedSum, setCheckedSum] = useState([]);
    const [checkedNote, setCheckedNote] = useState([]);
    const selectAllRef = useRef(null);
    const [openEditor, setOpenEditor] = useState(false);
    const [isSummary, setIsSummay] = useState(true);
    const [isNotes, setIsNotes] = useState(false);
    const [summay, setSummary] = useState([]);
    const [sessionID, setSessionID] = useState('');
    const [selectedSummary, setSelectedSummary] = useState('');
    const [selectedNotebookName, setSelectedNotebookName] = useState('');
    const [summaryId, setSummaryId] = useState();
    const [notes, setNotes] = useState([]);
    const [isExport, setIsExport] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState('')
    const services = new ApiServices();
    const [contextOpenId, setContextOpenId] = useState('');
    const [contextOpenIDNotes, setContextOpenIDNotes] = useState('');


    useEffect(() => {
        if (props.sessionID) {
            setSessionID(props.sessionID);
            // fetchSummary(props.sessionID);
        }
        if (props.selectedNotebookName) {
            setSelectedNotebookName(props.selectedNotebookName)
        }
    }, [])

    useEffect(() => {
        if (props.savedSummary) {
            setSummary(props.savedSummary)
        }
    }, [props.savedSummary])

    useEffect(() => {
        if (props.savedNotes) {
            setNotes(props.savedNotes)
        }
    }, [props.savedNotes])

    const fetchSummary = async (sessionID) => {
        let fetchSummary = await services.getAllNoteBookGenAISummary(sessionID);
        setSummary(fetchSummary)
    }
    const toggleItem = (id) => {
        setCheckedSum((prev) =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
    };
    const toggleItemNote = (id) => {
        setCheckedNote((prev) =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
    };
    const toggleSelectAll = (e) => {
        const value = e.target.checked;
        const next = {};
        for (const it of items) next[it.id] = value;
        setCheckedSum(next);
    };
    const hanadleOnClickSummary = (val, id, question) => {
        setSelectedSummary(val);
        setSelectedQuestion(question)
        setOpenEditor(true)
        setSummaryId(id)
    }
    const handleCloseSummary = () => {
        setOpenEditor(false)
        setSelectedSummary('');
        setSelectedQuestion('')
        setSummaryId(null);
    }
    const hanadleOnClickSummaryOption = () => {
        setIsSummay(true);
        setIsNotes(false);
    }
    const handleOnCickNotes = () => {
        setIsNotes(true)
        setIsSummay(false)
    }
    const getCleanText = (summary) => {
        let cleanText = summary.replace(/<[^>]*>/g, '');
        return cleanText
    }
    const handleExport = () => {
        setIsExport(true)
    }
    const handleUpdateCon = (_id) => {
        setContextOpenId(_id)
    }
    const handleNotesContext = (_id) => {
        setContextOpenIDNotes(_id)
    }

    return (
        <section className="sources-panel" aria-labelledby="sources-title">
            <header className="sources-header">
                <div className="source-header-content">
                    <div className={(isSummary) ? "header-left right-hd-selected header-cr" : "header-left header-cr"} style={{ padding: '0 12px' }} onClick={hanadleOnClickSummaryOption}>
                        <div className="header-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <path d="M19.7587 9.25375L18.9062 8.40125L18.7893 8.28437L15.1318 11.9419L13.0762 9.88625L16.7337 6.22875L16.2524 5.7475L15.8262 5.32125L15.7574 5.2525L12.0999 8.91L10.0718 6.875L13.7293 3.2175L13.6055 3.09375L12.753 2.24125L8.54555 6.44875L8.43555 6.60687L2.24805 18.7825L3.21742 19.7519L15.4137 13.5575L15.5718 13.4475L19.7587 9.25375ZM8.60742 15.4687C7.82367 15.8675 7.34242 16.1081 6.78555 15.5512L6.55867 15.3244L6.32492 15.0975C5.88492 14.6506 6.13242 14.1831 6.5243 13.3925L9.26055 8.01625L13.9905 12.7462L8.60742 15.4687Z" fill="black" />
                            </svg>
                        </div>
                        <h2 id="sources-title" className="title">Summary</h2>
                    </div>
                    <div className={(isNotes) ? "header-left right-hd-selected header-cr" : "header-left header-cr"} style={{ padding: '0 12px' }} onClick={handleOnCickNotes}>
                        <div className="header-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_1514_7622)">
                                    <path d="M9.33306 7.33325H5.3332M6.66649 9.99992H5.3332M10.6663 4.66659H5.3332M13.3329 4.53325V11.4666C13.3329 12.5867 13.3329 13.1467 13.1149 13.5746C12.9232 13.9509 12.6172 14.2569 12.2409 14.4486C11.8131 14.6666 11.2531 14.6666 10.133 14.6666H5.86651C4.74645 14.6666 4.18641 14.6666 3.75861 14.4486C3.3823 14.2569 3.07635 13.9509 2.88461 13.5746C2.66663 13.1467 2.66663 12.5867 2.66663 11.4666V4.53325C2.66663 3.41315 2.66663 2.85309 2.88461 2.42527C3.07635 2.04895 3.3823 1.74299 3.75861 1.55124C4.18641 1.33325 4.74645 1.33325 5.86651 1.33325H10.133C11.2531 1.33325 11.8131 1.33325 12.2409 1.55124C12.6172 1.74299 12.9232 2.04895 13.1149 2.42527C13.3329 2.85309 13.3329 3.41315 13.3329 4.53325Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1514_7622">
                                        <rect width="15.9994" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <h2 id="sources-title" className="title">Notes</h2>
                    </div>
                </div>
                <div className='source-header-divider'>
                    <div className="source-divider"></div>
                </div>
                {/*<div className="header-actions">
                    <button className="source-btn" type="button" aria-label="Add source">
                        <span className="btn-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.9996 4H11.8663C10.7463 4 10.1862 4 9.75841 4.21799C9.3821 4.40973 9.07615 4.7157 8.88441 5.09202C8.66643 5.51984 8.66643 6.0799 8.66643 7.2V8M13.9996 4L11.9996 2M13.9996 4L11.9996 6M6.6665 2H5.19989C4.07982 2 3.51979 2 3.09198 2.21799C2.71567 2.40973 2.40972 2.71569 2.21798 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21798 12.908C2.40972 13.2843 2.71567 13.5903 3.09198 13.782C3.51979 14 4.07982 14 5.19989 14H10.7997C11.9198 14 12.4798 14 12.9076 13.782C13.2839 13.5903 13.5899 13.2843 13.7816 12.908C13.9996 12.4802 13.9996 11.9201 13.9996 10.8V9.33333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="btn-text">Export</span>
                    </button>

                    <button className="source-btn" type="button" aria-label="Discover sources">
                        <span className="btn-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M7.99977 13.3333H13.9996M2 13.3333H3.11632C3.44243 13.3333 3.60549 13.3333 3.75893 13.2965C3.89498 13.2638 4.02503 13.21 4.14432 13.1368C4.27887 13.0544 4.39417 12.9391 4.62476 12.7085L12.9996 4.33333C13.5519 3.78104 13.5519 2.88561 12.9996 2.33333C12.4474 1.78104 11.552 1.78104 10.9997 2.33333L2.62482 10.7085C2.39422 10.9391 2.27893 11.0544 2.19647 11.1889C2.12337 11.3082 2.0695 11.4383 2.03684 11.5744C2 11.7278 2 11.8909 2 12.217V13.3333Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span className="btn-text">Notes</span>
                    </button>
                </div>*/}
            </header>

            <div className="sources-controls">
                {/* <label className="select-all">
                    <input
                        id="select-all"
                        type="checkbox"
                        ref={selectAllRef}
                        onChange={toggleSelectAll}
                        aria-label="Select all sources"
                    />
                    <span className="checkbox-custom" style={{ marginTop: '3px' }} aria-hidden="true"></span>
                    <span className="select-all-text">Select All</span>
                </label> */}
            </div>
            <div className="sources-list-ele">
                {(props.rightIsProcessing) ? <img src={imsLoader} alt="" width={50} /> : <ul className="sources-list" role="list" aria-labelledby="sources-title">
                    {(isSummary) && summay.map((x) => (
                        <SummaryDisplay
                            item={x}
                            handleOnOpenedContextMenuClick={handleUpdateCon}
                            openedContextMenuId={contextOpenId}
                            deleteSummary={props.deleteSummary}
                            hanadleOnClickSummary={hanadleOnClickSummary}
                            checked={checkedSum}
                            toggleItem={toggleItem}
                            getCleanText={getCleanText} />

                    ))}
                    {(isNotes) && notes.map((x) => (
                        <NotesDisplay
                            item={x}
                            handleOnOpenedContextMenuClick={handleNotesContext}
                            openedContextMenuId={contextOpenIDNotes}
                            deleteSummary={props.handleDeleteNotes}
                            hanadleOnClickSummary={hanadleOnClickSummary}
                            checked={checkedNote}
                            toggleItem={toggleItemNote}
                            getCleanText={getCleanText} />
                    ))}
                </ul>}
            </div>
            <div className="summary-panel-footer">
                <div className="summary-panel-export" style={{ marginRight: '10px' }} onClick={() => { handleExport() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.9996 4H11.8663C10.7463 4 10.1862 4 9.75841 4.21799C9.3821 4.40973 9.07615 4.7157 8.88441 5.09202C8.66643 5.51984 8.66643 6.0799 8.66643 7.2V8M13.9996 4L11.9996 2M13.9996 4L11.9996 6M6.6665 2H5.19989C4.07982 2 3.51979 2 3.09198 2.21799C2.71567 2.40973 2.40972 2.71569 2.21798 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21798 12.908C2.40972 13.2843 2.71567 13.5903 3.09198 13.782C3.51979 14 4.07982 14 5.19989 14H10.7997C11.9198 14 12.4798 14 12.9076 13.782C13.2839 13.5903 13.5899 13.2843 13.7816 12.908C13.9996 12.4802 13.9996 11.9201 13.9996 10.8V9.33333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span style={{ color: '#FFFF' }}>Export</span>
                </div>
                {/* <div className="summary-panel-export" onClick={() => { }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99977 13.3333H13.9996M2 13.3333H3.11632C3.44243 13.3333 3.60549 13.3333 3.75893 13.2965C3.89498 13.2638 4.02503 13.21 4.14432 13.1369C4.27887 13.0544 4.39417 12.9391 4.62476 12.7085L12.9996 4.33334C13.5519 3.78106 13.5519 2.88563 12.9996 2.33334C12.4474 1.78106 11.552 1.78106 10.9997 2.33334L2.62482 10.7085C2.39422 10.9391 2.27893 11.0544 2.19647 11.189C2.12337 11.3083 2.0695 11.4383 2.03684 11.5744C2 11.7278 2 11.8909 2 12.217V13.3333Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span style={{ color: '#FFFF' }}>Notes</span>
                </div> */}
            </div>
            {(isExport) && <NoteBookExport
                showPop={isExport}
                summary={summay}
                checkedSum={checkedSum}
                checkedNote={checkedNote}
                notes={notes}
                selectedNotebookName={selectedNotebookName}
                handleClose={() => setIsExport(false)}
                isSummary={isSummary}
                isNotes={isNotes} />}
            {(openEditor) && <NoteBookRichTextEditor
                showModal={openEditor}
                selectedSummary={selectedSummary}
                summaryId={summaryId}
                handleClose={handleCloseSummary}
                selectedNotebookName={selectedNotebookName}
                updateSummary={props.updateSummary}
                deleteSummary={props.deleteSummary}
                handleAddToSource={props.handleAddToSource}
                handeAddToNotes={props.handeAddToNotes}
                handleUpdateNotes={props.handleUpdateNotes}
                handleDeleteNotes={props.handleDeleteNotes}
                handleAddToSummary={props.handleAddToSummary}
                isSummary={isSummary}
                isNotes={isNotes}
                isEditSourceText={false}
                selectedQuestion={selectedQuestion} />}
        </section>
    );
}
const SummaryDisplay = (props) => {

    useEffect(() => {
        if (props.openedContextMenuId != `NB-${props.item.id}`) {
            hideMenu({
                id: `NB-${props.item.id}`
            });
        }
    }, [props.openedContextMenuId]);

    const handleLeftMouseClick = (e, _id) => {
        e.stopPropagation();
        const x = e.clientX;
        const y = e.clientY;
        props.handleOnOpenedContextMenuClick(_id);
        showMenu({
            position: { x, y },
            id: _id
        });

    }
    const onContextMenuHide = () => {
        props.handleOnOpenedContextMenuClick("");
    }
    return (<>
        <li className="source-item" key={props.item.id}>
            <div className="item-left">
                <label className="item-checkbox" aria-label={`Select ${props.item.user_summary}`}>
                    <input
                        type="checkbox"
                        checked={props.checked.includes(props.item.id)}
                        onChange={() => props.toggleItem(props.item.id)}
                    />
                    <span className="checkbox-custom" style={{ marginTop: '3px' }} aria-hidden="true">
                        <span className="check-mark"></span>
                    </span>
                </label>
                <div className="item-meta">
                    <div className="item-title" style={{ cursor: 'pointer' }} onClick={() => props.hanadleOnClickSummary(props.item.user_summary, props.item.id, props.item.user_question)} dangerouslySetInnerHTML={{ __html: sanitize(props.getCleanText(props.item.user_summary)) }} />
                </div>
            </div>
            <div className="item-actions">
                <ContextMenuTrigger id={`NB-${props.item.id}`}><button className="icon-btn summary-btn" type="button" aria-label={`Pin ${props.item.user_summary}`}
                    onClick={(e) => handleLeftMouseClick(e, `NB-${props.item.id}`)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99965 8.66666C8.36783 8.66666 8.66629 8.36818 8.66629 7.99999C8.66629 7.6318 8.36783 7.33332 7.99965 7.33332C7.63147 7.33332 7.33301 7.6318 7.33301 7.99999C7.33301 8.36818 7.63147 8.66666 7.99965 8.66666Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99965 3.99999C8.36783 3.99999 8.66629 3.70151 8.66629 3.33332C8.66629 2.96513 8.36783 2.66666 7.99965 2.66666C7.63147 2.66666 7.33301 2.96513 7.33301 3.33332C7.33301 3.70151 7.63147 3.99999 7.99965 3.99999Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99965 13.3333C8.36783 13.3333 8.66629 13.0348 8.66629 12.6667C8.66629 12.2985 8.36783 12 7.99965 12C7.63147 12 7.33301 12.2985 7.33301 12.6667C7.33301 13.0348 7.63147 13.3333 7.99965 13.3333Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                </ContextMenuTrigger>
                <ContextMenu id={`NB-${props.item.id}`} onHide={e => { onContextMenuHide(props.item.id) }}>
                    <MenuItem className="summary-delete-menu" onClick={() => props.deleteSummary(props.item.id)}>
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" class="svg-inline--fa fa-trash fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                        <span>Delete</span>
                    </MenuItem>
                </ContextMenu>
            </div>
        </li>
    </>)
}
const NotesDisplay = (props) => {

    useEffect(() => {
        if (props.openedContextMenuId != `NS-${props.item.id}`) {
            hideMenu({
                id: `NS-${props.item.id}`
            });
        }
    }, [props.openedContextMenuId]);

    const handleLeftMouseClick = (e, _id) => {
        e.stopPropagation();
        const x = e.clientX;
        const y = e.clientY;
        props.handleOnOpenedContextMenuClick(_id);
        showMenu({
            position: { x, y },
            id: _id
        });

    }
    const onContextMenuHide = () => {
        props.handleOnOpenedContextMenuClick("");
    }
    return (<>
        <li className="source-item" key={props.item.id}>
            <div className="item-left">
                <label className="item-checkbox" aria-label={`Select ${props.item.user_notes}`}>
                    <input
                        type="checkbox"
                        checked={props.checked.includes(props.item.id)}
                        onChange={() => props.toggleItem(props.item.id)}
                    />
                    <span className="checkbox-custom" style={{ marginTop: '3px' }} aria-hidden="true">
                        <span className="check-mark"></span>
                    </span>
                </label>
                <div className="item-meta">
                    <div className="item-title" style={{ cursor: 'pointer' }} onClick={() => props.hanadleOnClickSummary(props.item.user_notes, props.item.id, props.item.user_question)} dangerouslySetInnerHTML={{ __html: sanitize(props.getCleanText(props.item.user_notes)) }} />
                </div>
            </div>
            <div className="item-actions">
                <ContextMenuTrigger id={`NS-${props.item.id}`}><button className="icon-btn summary-btn" type="button" aria-label={`Pin ${props.item.user_notes}`}
                    onClick={(e) => handleLeftMouseClick(e, `NS-${props.item.id}`)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99965 8.66666C8.36783 8.66666 8.66629 8.36818 8.66629 7.99999C8.66629 7.6318 8.36783 7.33332 7.99965 7.33332C7.63147 7.33332 7.33301 7.6318 7.33301 7.99999C7.33301 8.36818 7.63147 8.66666 7.99965 8.66666Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99965 3.99999C8.36783 3.99999 8.66629 3.70151 8.66629 3.33332C8.66629 2.96513 8.36783 2.66666 7.99965 2.66666C7.63147 2.66666 7.33301 2.96513 7.33301 3.33332C7.33301 3.70151 7.63147 3.99999 7.99965 3.99999Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99965 13.3333C8.36783 13.3333 8.66629 13.0348 8.66629 12.6667C8.66629 12.2985 8.36783 12 7.99965 12C7.63147 12 7.33301 12.2985 7.33301 12.6667C7.33301 13.0348 7.63147 13.3333 7.99965 13.3333Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                </ContextMenuTrigger>
                <ContextMenu id={`NS-${props.item.id}`} onHide={e => { onContextMenuHide(props.item.id) }}>
                    <MenuItem className="summary-delete-menu" onClick={() => props.deleteSummary(props.item.id)}>
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" class="svg-inline--fa fa-trash fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                        <span>Delete</span>
                    </MenuItem>
                </ContextMenu>
            </div>
        </li>
    </>)
}